import { useMutation } from "@apollo/client";
import { REMOVE_USER_CUSTOMER } from "../user-customer.queries";
import {
  RemoveUserCustomerMutation,
  RemoveUserCustomerMutationVariables,
} from "../../../__generated__/RemoveUserCustomerMutation";

export const useRemoveUserCustomer = () => {
  return useMutation<
    RemoveUserCustomerMutation,
    RemoveUserCustomerMutationVariables
  >(REMOVE_USER_CUSTOMER, {
    refetchQueries: ["UserCustomersQuery"],
  });
};
